import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'


class DetailBloc {

    detailChannel = new Subject();
    generateChannel = new Subject();
    generatePaktaChannel = new Subject();
    generateSPPChannel = new Subject();
    generateSPMJChannel = new Subject();
    generateSPMTChannel = new Subject();
    docPelantikanChannel = new Subject();
    docPaktaChannel = new Subject();
    docSPPChannel = new Subject();
    docSPMJChannel = new Subject();
    docSPMTChannel = new Subject();
    inactiveChannel = new Subject();
    repository = new DetailRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchLevel = async (query) => {
        this.detailLevel.next({status: apiResponse.LOADING})
        await this.repository.fetchLevel(query).then((result) => {
            this.detailLevel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailLevel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchGenerateDocument = async (query) => {
        this.generateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateDocument(query).then((result) => {
            this.generateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchGenerateDocumentPakta = async (query) => {
        this.generatePaktaChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateDocumentPakta(query).then((result) => {
            this.generatePaktaChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generatePaktaChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchGenerateDocumentSPP = async (query) => {
        this.generateSPPChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateDocumentSPP(query).then((result) => {
            this.generateSPPChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generateSPPChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchGenerateDocumentSPMJ = async (query) => {
        this.generateSPMJChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateDocumentSPMJ(query).then((result) => {
            this.generateSPMJChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generateSPMJChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchGenerateDocumentSPMT = async (query) => {
        this.generateSPMTChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateDocumentSPMT(query).then((result) => {
            this.generateSPMTChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generateSPMTChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailDokpelantikan = async (query) => {
        this.docPelantikanChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailDokpelantikan(query).then((result) => {
            this.docPelantikanChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.docPelantikanChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailDokPakta = async (query) => {
        this.docPaktaChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailDokPakta(query).then((result) => {
            this.docPaktaChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.docPaktaChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailDokSPP = async (query) => {
        this.docSPPChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailDokSPP(query).then((result) => {
            this.docSPPChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.docSPPChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailDokSPMJ = async (query) => {
        this.docSPMJChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailDokSPMJ(query).then((result) => {
            this.docSPMJChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.docSPMJChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailDokSPMT = async (query) => {
        this.docSPMTChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailDokSPMT(query).then((result) => {
            this.docSPMTChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.docSPMTChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchInactive = async (query) => {
        this.inactiveChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchInactive(query).then((result) => {
            this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default DetailBloc